import { render, staticRenderFns } from "./ConfirmInvitation.vue?vue&type=template&id=bed14bda&"
import script from "./ConfirmInvitation.vue?vue&type=script&lang=js&"
export * from "./ConfirmInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports